<template>
  <div class = "card-curvey" style="">
    <h2>Campaigns</h2>
    <apex-chart type="bar" :options="options" :series="series"></apex-chart>
  </div>
</template>

<script>
  import apexChart from 'vue-apexcharts'
  export default {
    name: "campaignsBarChart",
    components: {
      apexChart
    },
    props: {
      overallData: {
        type: Object,
        default: ()=> {
          return {}
        }
      }
    },
    data () {
      return {
        options: {
          colors: [this.$vuetify.theme.secondary, this.$vuetify.theme.warning , '#1DE9B6', '#FF4560' , '#775DD0' , '#833B2B'],
          plotOptions: {
            bar: {
              borderRadius: 8,
              horizontal: false,
            },
          },
          chart: {
            id: 'campaigns-details'
          },
          fill: {
            opacity: 1
          },
          xaxis: {
            categories: []
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return value + "$";
              }
            },
          },
        },
        series: [

        ]
      }
    },
    mounted() {
      this.getChartsData()
    },
    methods: {
      getChartsData() {
        let categories = []
        for (let i=0; i<this.overallData.campaignsAnalytics.length;i++) {
          categories.push(this.overallData.campaignsAnalytics[i].name)
        }
        let label = null;
        for (let i=0;i<this.overallData.campaignsAnalytics[0].msg_status.length;i++){

          this.series[i] = {}
          label = this.overallData.campaignsAnalytics[0].msg_status[i].label === 'no feedback' ? 'Waiting Reply Back' : this.overallData.campaignsAnalytics[0].msg_status[i].label
          label = label === 'reply back' ? 'Replied Back' : label
          this.series[i].name = label
          this.series[i].data = []
          for (let j=0;j<this.overallData.campaignsAnalytics.length;j++) {
            this.series[i].data.push(this.overallData.campaignsAnalytics[j].msg_status[i].count)
          }
        }

        this.options = {
          legend: {
            position:'top'
          },
          chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
              show: true
            },
            zoom: {
              enabled: true
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 8,
              horizontal: false,
            },
          },
          xaxis: {
            categories: categories
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return Math.trunc(value);
              }
            },
          },
        }

      }




    }
  }
</script>

<style scoped>

</style>
